export const openUrl = (url) => {
    if (!url) return;
    if (window.HybridWebView && window.HybridWebView.SendRawMessage) {
        const callId = `cb_${Math.random().toString(36).substring(2, 9)}`;
        window[callId] = () => { delete window[callId]; };
        window.HybridWebView.SendRawMessage(`${callId}|OpenUrl|${url}`);
    } else {
        window.open(url, '_blank');
    }
};

export const callMaui = (action, data = "") => {
    return new Promise((resolve, reject) => {
        const callId = `cb_${Math.random().toString(36).substring(2, 9)}`;

        window[callId] = (response) => {
            console.log(`[Vue] Risposta ricevuta per ${action}:`, response);
            resolve(response);
            delete window[callId];
        };

        const payload = `${callId}|${action}|${data}`;
        console.log(`[Vue] Inviando a C#:`, payload);

        if (window.HybridWebView && window.HybridWebView.SendRawMessage) {
            window.HybridWebView.SendRawMessage(payload);
        } else {
            delete window[callId];
            console.error("HybridWebView non trovato!");
            reject("HybridWebView non trovato");
        }

        setTimeout(() => {
            if (window[callId]) {
                delete window[callId];
                reject(`Timeout su ${action}`);
            }
        }, 10000);
    });
};
